import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericService } from './generic.service';

@Injectable({
  providedIn: 'root'
})
export class ColetaService extends GenericService {

  constructor(http: HttpClient) {
    super(http, 'configuracao-coleta');
  }

  /**
   * GET /api/configuracao-coleta/{id}/estacoes-relacionadas
   * Lista estações vinculadas à configuração de coleta. Retorna existe e estacoes (id, nome).
   */
  getEstacoesRelacionadas(id: number): Observable<{ existe: boolean; estacoes: Array<{ id: number; nome: string }> }> {
    return this.http.get<any>(`${this.url_base}/${this.prefixo}/${id}/estacoes-relacionadas`);
  }
}
